// Search-state for the organisations index route. A thin instance of the
// shared resource list-page router-search factory; the route in
// organisations.routes.tsx owns the validateSearch schema via
// parseOrganisationsSearch.
//
// Organisations drops a dangling ?direction= when there is no valid sort
// column, so requireSortForDirection is on.

import { DEFAULT_PAGE_SIZE } from '@components/DataTable/constants';
import {
  createResourceRouterSearch,
  createResourceSearchParser,
  type ResourceListSearchParams,
  type ResourceSortDirection,
} from '@hooks/resourceListPage';

type OrganisationSortColumnValue = 'name' | 'created_at' | 'updated_at';

export type OrganisationSortColumn = OrganisationSortColumnValue | '';
export type OrganisationSortDirection = ResourceSortDirection;
export type OrganisationsSearchParams = ResourceListSearchParams<OrganisationSortColumnValue>;

// Default the list to name A→Z (the backend's organisations index defaults to
// the same name asc, so the SSR-seeded first page matches).
export const ORGANISATIONS_SEARCH_DEFAULTS: OrganisationsSearchParams = {
  q: '',
  page: 1,
  perPage: DEFAULT_PAGE_SIZE,
  sort: 'name',
  direction: 'asc',
};

const ORGANISATION_SORT_COLUMNS: ReadonlyArray<OrganisationSortColumnValue> = [
  'name',
  'created_at',
  'updated_at',
];

// validateSearch handler — coerces unknown URL input into the typed shape.
export const parseOrganisationsSearch = createResourceSearchParser<OrganisationSortColumnValue>({
  defaults: ORGANISATIONS_SEARCH_DEFAULTS,
  validSorts: ORGANISATION_SORT_COLUMNS,
  requireSortForDirection: true,
});

export const useOrganisationRouterSearch =
  createResourceRouterSearch<OrganisationSortColumnValue>('/organisations');
